(function tableOfContentsArticle () {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "table-of-contents-article";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }


    const generateToc = GlobalSite.checkDependency("GlobalSite.generateToc");

  $(() => {
    const contentSelector = "#article-content";
    const tocListSelector = "#table-of-contents-list";

    generateToc({
      contentSelector,
      tocContainerSelector: "#table-of-contents",
      tocListSelector
    });

    const headings = document.querySelectorAll(
      `${contentSelector} h2, ${contentSelector} h3`
    );

    const tocLinks = document.querySelectorAll(
      `${tocListSelector} a`
    );

    tocLinks.forEach((link, index) => {
      const heading = headings[index];

      if (!heading) {
        return;
      }

      if(!heading.id) {
        heading.id = `${compName}-heading-${index + 1}`;
      }

      link.setAttribute("href", `#${heading.id}`);
    });
  });
})();